import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ordersPathTo } from '../utils/Api';
import { Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SnackbarContext from '../contexts/SnackbarContext';

const DeliveryDetails = () => {
  const { id } = useParams();
  const [delivery, setDelivery] = useState(null);
  const navigate = useNavigate();
  const { openConfirmDialog } = useContext(SnackbarContext);

  useEffect(() => {
    ordersPathTo.get(id).then((result) => {
      setDelivery(result.data);
    });
  }, [id]);

  if (!delivery) {
    return <div>Carregando...</div>;
  }

  const handleOrderShipped = () => {
    openConfirmDialog('Confirma marcar como enviada?', () => {
      ordersPathTo.order_shipped(id).then((result) => {
        setDelivery(result.data);
      });
    });
  };

  const handleOrderDeliveryCancel = () => {
    openConfirmDialog('Confirma marcar como cancelada?', () => {
      ordersPathTo.remove_courier(id).then(() => {
        navigate('/delivery-dashboard');
      });
    });
  };

  return (
    <div>
      <h1>Delivery details</h1>
      <Typography><b>{delivery.id}</b></Typography>

      <Box>
        <Typography><b>Itens:</b></Typography>
        {delivery.order_items.map((item) => (
          <Box key={item.title}>
            <Typography>{item.title} x {item.quantity}</Typography>
          </Box>
        ))}
      </Box>

      <Box>
        <Typography><b>Endereço do Fornecedor:</b></Typography>
          {`${delivery.provider.address.logradouro}, ${delivery.provider.address.numero}, ${delivery.provider.address.bairro}, ${delivery.provider.address.localidade}`}
      </Box>

      <Box>
        <Typography><b>Endereço de Entrega:</b></Typography>
          {`${delivery.delivery_address}`}
      </Box>

      <Box>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOrderShipped}
          disabled={delivery.status !== 'courier'}
        >
          Marcar como enviada
        </Button>
        <Button 
          variant="outlined" 
          color="primary" 
          onClick={handleOrderDeliveryCancel} 
          disabled={delivery.status !== 'courier'}
        >
          Cancelar entrega
        </Button>
      </Box>
    </div>
  );
};

export default DeliveryDetails;
